import {
  MessageOutlined,
  QuestionCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Divider, Tooltip, Typography } from "antd";
import markdownit from "markdown-it";
import { Button, Card } from "@rumbledirect/ui";

const md = markdownit({ html: true, breaks: true });

export const AgentDossierKnowledgeBaseSummaryCard = ({
  setActiveTab,
  isLoading,
}: {
  setActiveTab: (tabKey: string) => void;
  isLoading: boolean;
}) => {
  return (
    <Card
      loading={isLoading}
      title={
        <Typography.Title style={{ marginTop: 8 }} level={5}>
          Ask Pet.
          <Tooltip title="Pet van Schadenet is een AI agent die informatie verzamelt op basis van opdrachtgever specifieke werkdocumenten.">
            <Button
              size="small"
              style={{ marginLeft: 8 }}
              icon={<QuestionCircleOutlined />}
            />
          </Tooltip>
        </Typography.Title>
      }
      className="w-full mb-5"
      extra={
        <Button
          icon={<MessageOutlined />}
          onClick={() => setActiveTab("knowledge-base")}
        >
          Ask Pet
        </Button>
      }
    >
      <Typography>
        <div
          dangerouslySetInnerHTML={{
            __html: md.render(
              "#### Schade Criteria\n\n- **Binnen criteria**:\n  - Repareren zonder toestemming is toegestaan als het voertuig jonger is dan 36 maanden en minder dan 120.000 km heeft gereden.\n  - Een toestemmingsnummer is verplicht, maar reparatie kan direct beginnen als het binnen de criteria valt.\n  - Afwijkingen in schadebedrag of planning moeten via ESA worden gemeld.\n\n- **Buiten criteria**:\n  - Indien de schade buiten de criteria valt, moet toestemming via e-mail worden aangevraagd voordat het ESA-proces wordt gestart.\n  - Criteria voor buiten criteria omvatten voertuigen ouder dan 36 maanden, boven de 120.000 km, dreigend total loss, of wanneer het schadebedrag meer dan 50% van de dagwaarde bedraagt.\n\n#### Vervangend Vervoer\n\n- **Algemeen**:\n  - De aangegeven klasse in ESA of ROB is niet altijd juist en moet handmatig worden geaccordeerd door Athlon.\n  - Schadenet vestigingen hebben een leveringsplicht voor klasse A tot en met C.\n  - Weekenddagen binnen de leveringsplicht mogen niet worden doorbelast.\n\n- **Tarieven**:\n  - Tarieven vari\u00ebren per klasse en omvatten dagtarieven, kilometervergoedingen, en eventuele toeslagen voor automaat.\n  - Voorbeelden van tarieven:\n    - Klasse A: \u20ac19,50 per dag, \u20ac0,10 per km.\n    - Klasse B: \u20ac29,50 per dag, \u20ac0,12 per km.\n    - Klasse C: \u20ac33,50 per dag, \u20ac0,14 per km.\n\n#### Total Loss\n\n- **Proces**:\n  - Indien er een vermoeden is of duidelijk is dat het voertuig total loss gaat, moet het ESA-proces worden gestopt en moet de calculatie en foto\u0027s per e-mail naar Athlon worden gestuurd.\n  - Athlon informeert de leaserijder over de total loss status.\n  - Overleg met Athlon is nodig over het verwijderen van stickers en de te factureren kosten.\n  - Indien het voertuig toch hersteld mag worden, moet het ESA-proces worden gestart en de calculatie en foto\u0027s naar Dekra worden verstuurd.",
            ),
          }}
        />
      </Typography>
      <Divider />
      <Typography.Paragraph className="mt-4 italic">
        <WarningOutlined className="mr-1" /> Pet van Schadenet maakt gebruik van
        AI en kan fouten bevatten. De verstrekte informatie kan onjuist of
        onvolledig zijn.
      </Typography.Paragraph>
    </Card>
  );
};
